import React, { useContext, useEffect, useState } from "react";
import { useDeleteComment, useRecentComment } from "./store";
import moment from "moment";
import Delete from "assets/svgs/delete";
import { useToast } from "modules/navbar/top/store/toasterStore";
import Yes from "assets/svgs/yes";
import No from "assets/svgs/no";
import secureLocalStorage from "react-secure-storage";
import { CustomerProps } from "./ShowCustomer";

function RecentComments({ setMessageFloater }) {
  const { setToaster } = useToast();
  const { fetchRecentCommentData, data } = useRecentComment();
  const { deleteComment } = useDeleteComment();
  const [deletePrompt, setDeletePrompt] = useState({});
  const { caseId } = useContext(CustomerProps);

  useEffect(() => {
    setMessageFloater(false);
    fetchRecentCommentData(caseId);
  }, [caseId]);

  useEffect(() => {}, [data]);

  const handleDelete = async (id) => {
    await deleteComment(id, setToaster);
    fetchRecentCommentData(caseId);
  };

  const showDeletePrompt = (id) => {
    setDeletePrompt((prevState) => ({
      ...prevState,
      [id]: true,
    }));
  };

  const hideDeletePrompt = (id) => {
    setDeletePrompt((prevState) => ({
      ...prevState,
      [id]: false,
    }));
  };

  return (
    <div>
      {Array.isArray(data) &&
        data.map((comment) => (
          <div
            key={comment.id}
            className="border border-warning rounded m-2 p-2"
          >
            <div className="d-flex justify-content-between align-items-end">
              <p className="text-warning fw-bold m-0">
                {comment.user.first_name}
              </p>
              <small className="text-black">
                {moment(comment.updated_at).format("MMM Do YYYY, h:mm a")}
              </small>
            </div>
            <div className="d-flex justify-content-between mt-2">
              <p className="mb-0 text-black">{comment.comment_text}</p>
              {comment.type === "normal" &&
                secureLocalStorage.getItem("id") === comment.user.id && (
                  <div className="cursor-pointer">
                    {deletePrompt[comment.id] ? (
                      <span className="mb-0 mx-1">
                        <span className="text-warning fw-bold me-2">
                          Want to delete the comment
                        </span>
                        <span onClick={() => handleDelete(comment.id)}>
                          <Yes />
                        </span>
                        <span onClick={() => hideDeletePrompt(comment.id)}>
                          <No />
                        </span>
                      </span>
                    ) : (
                      <div onClick={() => showDeletePrompt(comment.id)}>
                        <Delete />
                      </div>
                    )}
                  </div>
                )}
            </div>
          </div>
        ))}
    </div>
  );
}

export default RecentComments;
